
import Vue from 'vue'
import Component from 'vue-class-component'

import { MergeUserAccountsCallable, mergeUserAccountsId } from '@codee-club/common/dist/api-callables'

import Routes from '@/router/routes'
import firebase, { db, FieldValue } from '~/firebase-initialized'

@Component
export default class GoogleSignInButton extends Vue {
  async attemptGoogleLogin(): Promise<void> {
    const provider = new firebase.auth.GoogleAuthProvider()
    try {
      const result = await this.$auth.signInWithPopup(provider)
      const user = result.user

      if (user) {
        // Check if user document exists in Firestore
        const userDoc = await db.collection('users').doc(user.uid).get()
        if (!userDoc.exists) {
          // Create user profile
          const name = user.displayName || 'Anonymous'
          const nameParts = name.split(' ')
          const nameFirst = nameParts[0]
          const nameLast = nameParts.slice(1).join(' ') || ''

          await db.collection('users').doc(user.uid).set({
            name,
            nameFirst,
            nameLast,
            createdAt: FieldValue.serverTimestamp(),
            roles: []
          })

          await db.collection('usersPrivate').doc(user.uid).set({
            email: user.email || '',
            createdAt: FieldValue.serverTimestamp()
          })
        }

        // Check for legacy account and merge if necessary
        const mergeUserAccounts: MergeUserAccountsCallable = this.$functions.httpsCallable(mergeUserAccountsId)
        const { data: mergeResult } = await mergeUserAccounts()
        if (mergeResult.merged) {
          this.$buefy.toast.open({
            message: 'Your account has been successfully merged.',
            type: 'is-success'
          })
        }
      }

      // Check if we are already on the home page or need to redirect
      if (this.$route.name !== Routes.MainHome) {
        await this.$router.push({ name: Routes.MainHome })
      }
    } catch (error) {
      console.error('Google Sign In Error:', error)
      this.$buefy.toast.open({
        message: 'Failed to sign in with Google.',
        type: 'is-danger'
      })
    }
  }
}
